import { render, staticRenderFns } from "./chatSessions.vue?vue&type=template&id=7d37a9a0&scoped=true"
import script from "./chatSessions.vue?vue&type=script&lang=js"
export * from "./chatSessions.vue?vue&type=script&lang=js"
import style0 from "./chatSessions.vue?vue&type=style&index=0&id=7d37a9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d37a9a0",
  null
  
)

export default component.exports